// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --schedule-surface: #f5f7fa;
  --schedule-card-bg: #ffffff;
  --schedule-card-radius: 16px;
  --schedule-card-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
  --schedule-card-shadow-hover: 0 4px 24px rgba(0, 0, 0, 0.10);
  --schedule-text-primary: #1a1a2e;
  --schedule-text-secondary: #6b7280;
  --schedule-text-tertiary: #9ca3af;
  --schedule-pill-radius: 100px;
  --schedule-transition: 250ms cubic-bezier(0.4, 0, 0.2, 1);
  --schedule-spring: 400ms cubic-bezier(0.34, 1.56, 0.64, 1);
}

ion-header ion-toolbar {
  --padding-start: 8px;
  --padding-end: 8px;
  --min-height: 52px;
}
ion-header ion-toolbar ion-title {
  font-family: var(--font);
  font-weight: 600;
  font-size: 1.1rem;
  letter-spacing: -0.01em;
}
ion-header ion-toolbar ion-buttons ion-back-button, ion-header ion-toolbar ion-buttons ion-menu-button {
  --color: currentColor;
}
ion-header ion-toolbar ion-searchbar {
  --border-radius: 12px;
  --box-shadow: none;
  --background: rgba(255, 255, 255, 0.15);
  padding: 0 4px;
  font-size: 0.9rem;
}

.date-pill-strip-container {
  position: relative;
  display: flex;
  align-items: center;
  background: var(--schedule-surface);
}

.date-pill-strip {
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  overflow-x: auto;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  background: var(--schedule-surface);
  flex: 1;
}
.date-pill-strip::-webkit-scrollbar {
  display: none;
}
.date-pill-strip .date-pill {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 20px;
  border-radius: var(--schedule-pill-radius);
  background: var(--schedule-card-bg);
  border: 1px solid rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: all var(--schedule-transition);
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  opacity: 0;
  transform: translateY(8px);
  animation: pillFadeIn 350ms ease-out forwards;
}
.date-pill-strip .date-pill:nth-child(1) {
  animation-delay: 30ms;
}
.date-pill-strip .date-pill:nth-child(2) {
  animation-delay: 60ms;
}
.date-pill-strip .date-pill:nth-child(3) {
  animation-delay: 90ms;
}
.date-pill-strip .date-pill:nth-child(4) {
  animation-delay: 120ms;
}
.date-pill-strip .date-pill:nth-child(5) {
  animation-delay: 150ms;
}
.date-pill-strip .date-pill:nth-child(6) {
  animation-delay: 180ms;
}
.date-pill-strip .date-pill:nth-child(7) {
  animation-delay: 210ms;
}
.date-pill-strip .date-pill:nth-child(8) {
  animation-delay: 240ms;
}
.date-pill-strip .date-pill:nth-child(9) {
  animation-delay: 270ms;
}
.date-pill-strip .date-pill:nth-child(10) {
  animation-delay: 300ms;
}
.date-pill-strip .date-pill:nth-child(11) {
  animation-delay: 330ms;
}
.date-pill-strip .date-pill:nth-child(12) {
  animation-delay: 360ms;
}
.date-pill-strip .date-pill:nth-child(13) {
  animation-delay: 390ms;
}
.date-pill-strip .date-pill:nth-child(14) {
  animation-delay: 420ms;
}
.date-pill-strip .date-pill:nth-child(15) {
  animation-delay: 450ms;
}
.date-pill-strip .date-pill:nth-child(16) {
  animation-delay: 480ms;
}
.date-pill-strip .date-pill:nth-child(17) {
  animation-delay: 510ms;
}
.date-pill-strip .date-pill:nth-child(18) {
  animation-delay: 540ms;
}
.date-pill-strip .date-pill:nth-child(19) {
  animation-delay: 570ms;
}
.date-pill-strip .date-pill:nth-child(20) {
  animation-delay: 600ms;
}
.date-pill-strip .date-pill .pill-label {
  font-family: var(--font);
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--schedule-text-secondary);
  white-space: nowrap;
  transition: color var(--schedule-transition);
}
.date-pill-strip .date-pill:hover {
  background: rgba(0, 0, 0, 0.03);
}
.date-pill-strip .date-pill:active {
  transform: scale(0.95);
}
.date-pill-strip .date-pill.active {
  background: var(--menu-color, #2973a2);
  border-color: var(--menu-color, #2973a2);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}
.date-pill-strip .date-pill.active .pill-label {
  color: var(--menu-text-color, #ffffff);
  font-weight: 600;
}
.date-pill-strip .date-pill.today::after {
  content: "";
  position: absolute;
  top: 4px;
  right: 4px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ef4444;
}
.date-pill-strip .date-pill.active.today::after {
  background: rgba(255, 255, 255, 0.7);
}

.scroll-btn {
  display: none;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: var(--schedule-card-bg);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: var(--schedule-text-secondary);
  cursor: pointer;
  flex-shrink: 0;
  z-index: 2;
  transition: all var(--schedule-transition);
  margin: 0 4px;
}
.scroll-btn ion-icon {
  font-size: 1rem;
}
.scroll-btn:hover {
  background: color-mix(in srgb, var(--menu-color, #2973a2) 10%, white);
  color: var(--menu-color, #2973a2);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.14);
}
.scroll-btn:active {
  transform: scale(0.9);
}

@media screen and (min-width: 768px) {
  .scroll-btn {
    display: flex;
  }
}
.schedule-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px 12px;
  background: var(--schedule-surface);
}
.schedule-toolbar .toolbar-search {
  flex: 1;
  position: relative;
}
.schedule-toolbar .toolbar-search ion-searchbar {
  --border-radius: 12px;
  --box-shadow: none;
  --background: var(--schedule-card-bg);
  --placeholder-color: var(--schedule-text-tertiary);
  --placeholder-font-weight: 400;
  --icon-color: var(--schedule-text-tertiary);
  --clear-button-color: var(--schedule-text-tertiary);
  --cancel-button-color: var(--menu-color, #2973a2);
  padding: 0;
  height: 42px;
  font-family: var(--font);
  font-size: 0.9rem;
  transition: all var(--schedule-transition);
}
.schedule-toolbar .toolbar-search ion-searchbar.sc-ion-searchbar-ios {
  --background: var(--schedule-card-bg);
}
.schedule-toolbar .toolbar-search ion-searchbar.searchbar-collapsed {
  --background: color-mix(in srgb, var(--menu-color, #2973a2) 4%, white);
  --placeholder-color: var(--schedule-text-tertiary);
}
.schedule-toolbar .toolbar-search ion-searchbar.searchbar-collapsed .searchbar-input-container {
  border: 1px solid rgba(0, 0, 0, 0.04);
}
.schedule-toolbar .toolbar-search ion-searchbar.searchbar-collapsed .searchbar-cancel-button {
  display: none !important;
}
.schedule-toolbar .toolbar-search ion-searchbar:focus-within, .schedule-toolbar .toolbar-search ion-searchbar.searchbar-has-focus {
  --background: white;
  --box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.ics-download-row {
  display: flex;
  justify-content: center;
  padding: 4px 16px 12px;
  background: var(--schedule-surface);
}
.ics-download-row .ics-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  border-radius: var(--schedule-pill-radius);
  font-family: var(--font);
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--schedule-transition);
  border: none;
  background: color-mix(in srgb, var(--menu-color, #2973a2) 10%, white);
  color: var(--menu-color, #2973a2);
}
.ics-download-row .ics-button ion-icon {
  font-size: 1rem;
}
.ics-download-row .ics-button:hover {
  background: color-mix(in srgb, var(--menu-color, #2973a2) 18%, white);
}
.ics-download-row .ics-button:active {
  transform: scale(0.97);
}

.schedule-timeline {
  padding: 8px 16px 80px;
  background: var(--schedule-surface);
  position: relative;
}
.schedule-timeline::before {
  content: "";
  position: absolute;
  left: 27px;
  top: 12px;
  bottom: 12px;
  width: 2px;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 2px;
  pointer-events: none;
}

.session-card-wrapper {
  position: relative;
  margin-bottom: 12px;
  opacity: 0;
  transform: translateY(12px);
  animation: cardFadeIn 400ms ease-out forwards;
}
.session-card-wrapper:nth-child(1) {
  animation-delay: 30ms;
}
.session-card-wrapper:nth-child(2) {
  animation-delay: 60ms;
}
.session-card-wrapper:nth-child(3) {
  animation-delay: 90ms;
}
.session-card-wrapper:nth-child(4) {
  animation-delay: 120ms;
}
.session-card-wrapper:nth-child(5) {
  animation-delay: 150ms;
}
.session-card-wrapper:nth-child(6) {
  animation-delay: 180ms;
}
.session-card-wrapper:nth-child(7) {
  animation-delay: 210ms;
}
.session-card-wrapper:nth-child(8) {
  animation-delay: 240ms;
}
.session-card-wrapper:nth-child(9) {
  animation-delay: 270ms;
}
.session-card-wrapper:nth-child(10) {
  animation-delay: 300ms;
}
.session-card-wrapper:nth-child(11) {
  animation-delay: 330ms;
}
.session-card-wrapper:nth-child(12) {
  animation-delay: 360ms;
}
.session-card-wrapper:nth-child(13) {
  animation-delay: 390ms;
}
.session-card-wrapper:nth-child(14) {
  animation-delay: 420ms;
}
.session-card-wrapper:nth-child(15) {
  animation-delay: 450ms;
}
.session-card-wrapper:nth-child(16) {
  animation-delay: 480ms;
}
.session-card-wrapper:nth-child(17) {
  animation-delay: 510ms;
}
.session-card-wrapper:nth-child(18) {
  animation-delay: 540ms;
}
.session-card-wrapper:nth-child(19) {
  animation-delay: 570ms;
}
.session-card-wrapper:nth-child(20) {
  animation-delay: 600ms;
}
.session-card-wrapper:nth-child(21) {
  animation-delay: 630ms;
}
.session-card-wrapper:nth-child(22) {
  animation-delay: 660ms;
}
.session-card-wrapper:nth-child(23) {
  animation-delay: 690ms;
}
.session-card-wrapper:nth-child(24) {
  animation-delay: 720ms;
}
.session-card-wrapper:nth-child(25) {
  animation-delay: 750ms;
}
.session-card-wrapper:nth-child(26) {
  animation-delay: 780ms;
}
.session-card-wrapper:nth-child(27) {
  animation-delay: 810ms;
}
.session-card-wrapper:nth-child(28) {
  animation-delay: 840ms;
}
.session-card-wrapper:nth-child(29) {
  animation-delay: 870ms;
}
.session-card-wrapper:nth-child(30) {
  animation-delay: 900ms;
}

.session-card {
  --card-tint: color-mix(in srgb, var(--session-track-color, transparent) 11%, var(--schedule-card-bg));
  background: var(--card-tint);
  border-radius: var(--schedule-card-radius);
  box-shadow: var(--schedule-card-shadow);
  padding: 14px 16px;
  cursor: pointer;
  transition: all var(--schedule-transition);
  position: relative;
  overflow: hidden;
  border: 1px solid transparent;
}
.session-card:hover {
  box-shadow: var(--schedule-card-shadow-hover), 0 0 0 1px color-mix(in srgb, var(--session-track-color, rgba(0, 0, 0, 0.04)) 18%, transparent);
  transform: translateY(-1px);
}
.session-card:active {
  transform: scale(0.98);
  box-shadow: var(--schedule-card-shadow);
}
.session-card.is-past {
  opacity: 0.4;
  filter: grayscale(0.4);
}
.session-card.is-now {
  border-color: color-mix(in srgb, #ef4444 25%, transparent);
  box-shadow: 0 2px 20px rgba(239, 68, 68, 0.1), var(--schedule-card-shadow);
}
.session-card.is-now:hover {
  box-shadow: 0 4px 28px rgba(239, 68, 68, 0.15), var(--schedule-card-shadow-hover);
}

.card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.card-top .card-time {
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: var(--font);
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--schedule-text-primary);
  font-variant-numeric: tabular-nums;
}
.card-top .card-time ion-icon {
  font-size: 0.85rem;
  color: var(--schedule-text-tertiary);
}
.card-top .card-time .live-indicator {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 700;
  font-size: 0.7rem;
  color: #ef4444;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.card-top .card-time .live-indicator .live-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #ef4444;
  animation: livePulse 1.5s ease-in-out infinite;
}
.card-top .card-tracks {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.track-chip {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  line-height: 1.5;
}

.card-availability-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 5px;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 0.68rem;
  font-weight: 600;
  line-height: 1.5;
}
.card-availability-badge ion-icon {
  font-size: 0.8rem;
}
.card-availability-badge.sold-out {
  background: rgba(239, 68, 68, 0.1);
  color: #dc2626;
}
.card-availability-badge.few-tickets {
  background: rgba(245, 158, 11, 0.1);
  color: #d97706;
}

.card-title {
  font-family: var(--font);
  font-size: 1rem;
  font-weight: 600;
  color: var(--schedule-text-primary);
  margin: 0 0 8px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-speakers {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 8px;
}

.card-speaker {
  display: flex;
  align-items: center;
  gap: 8px;
}
.card-speaker .speaker-avatar {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  object-fit: cover;
  background: var(--schedule-surface);
  flex-shrink: 0;
}
.card-speaker .speaker-avatar-placeholder {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: color-mix(in srgb, var(--menu-color, #2973a2) 12%, white);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.card-speaker .speaker-avatar-placeholder ion-icon {
  font-size: 0.7rem;
  color: var(--menu-color, #2973a2);
}
.card-speaker .speaker-info {
  display: flex;
  flex-direction: column;
}
.card-speaker .speaker-info .speaker-name {
  font-family: var(--font);
  font-size: 0.78rem;
  font-weight: 500;
  color: var(--schedule-text-primary);
  line-height: 1.2;
}
.card-speaker .speaker-info .speaker-title {
  font-family: var(--font);
  font-size: 0.68rem;
  color: var(--schedule-text-tertiary);
  line-height: 1.2;
}

.card-description {
  font-family: var(--font);
  font-size: 0.78rem;
  color: var(--schedule-text-secondary);
  line-height: 1.5;
  position: relative;
  max-height: 2.4em;
  overflow: hidden;
}
.card-description::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1.2em;
  background: linear-gradient(to bottom, transparent, var(--card-tint));
  pointer-events: none;
}

.card-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 4px;
  padding-top: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.04);
}
.card-bottom .card-locations {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.card-bottom .card-actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.location-chip {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-family: var(--font);
  font-size: 0.72rem;
  color: var(--schedule-text-secondary);
}
.location-chip ion-icon {
  font-size: 0.78rem;
  color: var(--schedule-text-tertiary);
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all var(--schedule-transition);
  color: var(--schedule-text-tertiary);
}
.action-btn ion-icon {
  font-size: 1rem;
}
.action-btn:hover {
  background: rgba(0, 0, 0, 0.04);
  color: var(--schedule-text-secondary);
}
.action-btn:active {
  transform: scale(0.9);
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 32px;
  text-align: center;
}
.empty-state .empty-illustration {
  width: 120px;
  height: 120px;
  margin-bottom: 20px;
  border-radius: 60px;
  background: color-mix(in srgb, var(--menu-color, #2973a2) 8%, white);
  display: flex;
  align-items: center;
  justify-content: center;
}
.empty-state .empty-illustration ion-icon {
  font-size: 3rem;
  color: var(--menu-color, #2973a2);
  opacity: 0.5;
  animation: floatIcon 3s ease-in-out infinite;
}
.empty-state .empty-title {
  font-family: var(--font);
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--schedule-text-primary);
  margin: 0 0 6px;
}
.empty-state .empty-text {
  font-family: var(--font);
  font-size: 0.85rem;
  color: var(--schedule-text-tertiary);
  margin: 0 0 20px;
  max-width: 240px;
  line-height: 1.5;
}
.empty-state .empty-cta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 24px;
  border-radius: var(--schedule-pill-radius);
  font-family: var(--font);
  font-size: 0.85rem;
  font-weight: 500;
  background: var(--menu-color, #2973a2);
  color: var(--menu-text-color, #ffffff);
  border: none;
  cursor: pointer;
  transition: all var(--schedule-transition);
}
.empty-state .empty-cta:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
.empty-state .empty-cta:active {
  transform: scale(0.97);
}

.skeleton-list {
  padding: 8px 16px;
  background: var(--schedule-surface);
}
.skeleton-list .skeleton-card {
  background: var(--schedule-card-bg);
  border-radius: var(--schedule-card-radius);
  padding: 16px;
  margin-bottom: 12px;
  margin-left: 36px;
  position: relative;
}
.skeleton-list .skeleton-card::before {
  content: "";
  position: absolute;
  left: -27px;
  top: 20px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--schedule-surface);
  border: 2px solid rgba(0, 0, 0, 0.06);
}
.skeleton-list .skeleton-card .skeleton-line {
  height: 12px;
  border-radius: 6px;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.03) 0%, rgba(0, 0, 0, 0.07) 40%, rgba(0, 0, 0, 0.03) 80%);
  background-size: 300% 100%;
  animation: shimmer 1.8s ease-in-out infinite;
  margin-bottom: 10px;
}
.skeleton-list .skeleton-card .skeleton-line:nth-child(1) {
  width: 30%;
  height: 10px;
}
.skeleton-list .skeleton-card .skeleton-line:nth-child(2) {
  width: 90%;
  height: 14px;
}
.skeleton-list .skeleton-card .skeleton-line:nth-child(3) {
  width: 60%;
}
.skeleton-list .skeleton-card .skeleton-line:nth-child(4) {
  width: 45%;
  margin-bottom: 0;
}
.skeleton-list .skeleton-card .skeleton-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
.skeleton-list .skeleton-card .skeleton-row .skeleton-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.03) 0%, rgba(0, 0, 0, 0.07) 40%, rgba(0, 0, 0, 0.03) 80%);
  background-size: 300% 100%;
  animation: shimmer 1.8s ease-in-out infinite;
}
.skeleton-list .skeleton-card .skeleton-row .skeleton-name {
  height: 10px;
  width: 130px;
  border-radius: 5px;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.03) 0%, rgba(0, 0, 0, 0.07) 40%, rgba(0, 0, 0, 0.03) 80%);
  background-size: 300% 100%;
  animation: shimmer 1.8s ease-in-out infinite;
}

.filter-sheet {
  --backdrop-opacity: 0.3;
  --border-radius: 24px 24px 0 0;
}

.filter-sheet-content {
  --background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  padding: 0 20px 28px;
  animation: sheetFadeIn 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}
.filter-sheet-content::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  height: 300px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  pointer-events: none;
  z-index: -1;
}

@keyframes sheetFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.sheet-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.sheet-header .sheet-title {
  flex: 1;
  font-family: var(--font);
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--schedule-text-primary);
  margin: 0;
  letter-spacing: -0.01em;
}
.sheet-header .sheet-clear {
  font-family: var(--font);
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--menu-color, #2973a2);
  background: transparent;
  border: 1.5px solid color-mix(in srgb, var(--menu-color, #2973a2) 25%, transparent);
  cursor: pointer;
  padding: 5px 12px;
  border-radius: 100px;
  transition: all var(--schedule-transition);
}
.sheet-header .sheet-clear:hover {
  background: color-mix(in srgb, var(--menu-color, #2973a2) 8%, transparent);
}
.sheet-header .sheet-clear:active {
  transform: scale(0.95);
}
.sheet-header .sheet-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.05);
  border: none;
  cursor: pointer;
  color: var(--schedule-text-tertiary);
  font-size: 1rem;
  transition: all var(--schedule-transition);
}
.sheet-header .sheet-close:hover {
  background: rgba(0, 0, 0, 0.08);
  color: var(--schedule-text-secondary);
}
.sheet-header .sheet-close:active {
  transform: scale(0.9);
}

.sheet-section {
  background: rgba(0, 0, 0, 0.02);
  border-radius: 14px;
  padding: 14px;
  margin-bottom: 12px;
  animation: sheetSectionIn 0.4s ease forwards;
  opacity: 0;
}
.sheet-section:nth-child(1) {
  animation-delay: 0.1s;
}
.sheet-section:nth-child(2) {
  animation-delay: 0.18s;
}
.sheet-section:nth-child(3) {
  animation-delay: 0.26s;
}
.sheet-section .sheet-section-title {
  font-family: var(--font);
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--schedule-text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin: 0 0 10px;
}
.sheet-section .sheet-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

@keyframes sheetSectionIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.sheet-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: var(--schedule-pill-radius);
  font-family: var(--font);
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--schedule-text-secondary);
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1.5px solid rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: all var(--schedule-transition);
  -webkit-user-select: none;
          user-select: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), inset 0 1px 0 rgba(255, 255, 255, 0.5);
}
.sheet-chip .chip-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  transition: box-shadow var(--schedule-transition);
}
.sheet-chip:hover {
  border-color: rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06), inset 0 1px 0 rgba(255, 255, 255, 0.5);
}
.sheet-chip:active {
  transform: scale(0.96);
}
.sheet-chip.active {
  background: color-mix(in srgb, var(--menu-color, #2973a2) 12%, rgba(255, 255, 255, 0.9));
  border-color: var(--menu-color, #2973a2);
  color: var(--menu-color, #2973a2);
  font-weight: 600;
  box-shadow: 0 2px 8px color-mix(in srgb, var(--menu-color, #2973a2) 15%, transparent), inset 0 1px 0 rgba(255, 255, 255, 0.6);
}
.sheet-chip.active .chip-dot {
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--menu-color, #2973a2) 20%, transparent);
}
.sheet-chip.sheet-chip-location ion-icon {
  font-size: 0.85rem;
  opacity: 0.6;
  transition: opacity var(--schedule-transition);
}
.sheet-chip.sheet-chip-location.active ion-icon {
  opacity: 1;
}

.filter-fab {
  position: fixed;
  bottom: 24px;
  right: 20px;
  z-index: 100;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: var(--menu-color, #2973a2);
  color: var(--menu-text-color, #ffffff);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  cursor: pointer;
  transition: all var(--schedule-spring);
  -webkit-user-select: none;
          user-select: none;
}
.filter-fab ion-icon {
  font-size: 1.3rem;
}
.filter-fab .filter-fab-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  background: #ef4444;
  color: white;
  font-size: 0.65rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
.filter-fab:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.22);
}
.filter-fab:active {
  transform: scale(0.92);
}

@media screen and (min-width: 768px) {
  .filter-fab {
    bottom: 32px;
    right: calc(50% - 480px + 20px);
  }
}
@keyframes cardFadeIn {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
@keyframes floatIcon {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
}
@keyframes pillFadeIn {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes livePulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(0.8);
  }
}
@media screen and (min-width: 768px) {
  .schedule-timeline,
  .date-pill-strip-container,
  .schedule-toolbar,
  .ics-download-row,
  .skeleton-list,
  .empty-state {
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
  }
  .empty-state {
    padding: 80px 16px;
  }
}
@media screen and (min-width: 769px) {
  .date-pill-strip {
    padding: 12px 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/schedule/schedule.page.scss"],"names":[],"mappings":"AAMA;EACE,2BAAA;EACA,2BAAA;EACA,4BAAA;EACA,sDAAA;EACA,4DAAA;EACA,gCAAA;EACA,kCAAA;EACA,iCAAA;EACA,6BAAA;EACA,yDAAA;EACA,0DAAA;AALF;;AAYE;EACE,oBAAA;EACA,kBAAA;EACA,kBAAA;AATJ;AAWI;EACE,wBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AATN;AAaM;EACE,qBAAA;AAXR;AAeI;EACE,qBAAA;EACA,kBAAA;EACA,uCAAA;EACA,cAAA;EACA,iBAAA;AAbN;;AAqBA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mCAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iCAAA;EACA,qBAAA;EACA,mCAAA;EACA,OAAA;AAlBF;AAoBE;EACE,aAAA;AAlBJ;AAqBE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,0CAAA;EACA,mCAAA;EACA,qCAAA;EACA,eAAA;EACA,0CAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,0BAAA;EACA,6CAAA;AAnBJ;AAsBM;EACE,qBAAA;AApBR;AAmBM;EACE,qBAAA;AAjBR;AAgBM;EACE,qBAAA;AAdR;AAaM;EACE,sBAAA;AAXR;AAUM;EACE,sBAAA;AARR;AAOM;EACE,sBAAA;AALR;AAIM;EACE,sBAAA;AAFR;AACM;EACE,sBAAA;AACR;AAFM;EACE,sBAAA;AAIR;AALM;EACE,sBAAA;AAOR;AARM;EACE,sBAAA;AAUR;AAXM;EACE,sBAAA;AAaR;AAdM;EACE,sBAAA;AAgBR;AAjBM;EACE,sBAAA;AAmBR;AApBM;EACE,sBAAA;AAsBR;AAvBM;EACE,sBAAA;AAyBR;AA1BM;EACE,sBAAA;AA4BR;AA7BM;EACE,sBAAA;AA+BR;AAhCM;EACE,sBAAA;AAkCR;AAnCM;EACE,sBAAA;AAqCR;AAjCI;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qCAAA;EACA,mBAAA;EACA,4CAAA;AAmCN;AAhCI;EACE,+BAAA;AAkCN;AA/BI;EACE,sBAAA;AAiCN;AA9BI;EACE,sCAAA;EACA,wCAAA;EACA,yCAAA;AAgCN;AA9BM;EACE,sCAAA;EACA,gBAAA;AAgCR;AA3BM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AA6BR;AAzBI;EACE,oCAAA;AA2BN;;AAtBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,mCAAA;EACA,wCAAA;EACA,qCAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,0CAAA;EACA,aAAA;AAyBF;AAvBE;EACE,eAAA;AAyBJ;AAtBE;EACE,qEAAA;EACA,iCAAA;EACA,0CAAA;AAwBJ;AArBE;EACE,qBAAA;AAuBJ;;AAnBA;EACE;IACE,aAAA;EAsBF;AACF;AAhBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,mCAAA;AAkBF;AAhBE;EACE,OAAA;EACA,kBAAA;AAkBJ;AAhBI;EACE,qBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kDAAA;EACA,8BAAA;EACA,2CAAA;EACA,mDAAA;EACA,iDAAA;EACA,UAAA;EACA,YAAA;EACA,wBAAA;EACA,iBAAA;EACA,0CAAA;AAkBN;AAhBM;EACE,qCAAA;AAkBR;AAfM;EACE,sEAAA;EACA,kDAAA;AAiBR;AAfQ;EACE,qCAAA;AAiBV;AAdQ;EACE,wBAAA;AAgBV;AAZM;EAEE,mBAAA;EACA,2CAAA;AAaR;;AAJA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mCAAA;AAOF;AALE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,0CAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,0CAAA;EACA,YAAA;EACA,qEAAA;EACA,iCAAA;AAOJ;AALI;EACE,eAAA;AAON;AAJI;EACE,qEAAA;AAMN;AAHI;EACE,sBAAA;AAKN;;AAGA;EACE,sBAAA;EACA,mCAAA;EAGA,kBAAA;AAFF;AAIE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,+BAAA;EACA,kBAAA;EACA,oBAAA;AAFJ;;AASA;EACE,kBAAA;EACA,mBAAA;EAGA,UAAA;EACA,2BAAA;EACA,6CAAA;AARF;AAWI;EACE,qBAAA;AATN;AAQI;EACE,qBAAA;AANN;AAKI;EACE,qBAAA;AAHN;AAEI;EACE,sBAAA;AAAN;AADI;EACE,sBAAA;AAGN;AAJI;EACE,sBAAA;AAMN;AAPI;EACE,sBAAA;AASN;AAVI;EACE,sBAAA;AAYN;AAbI;EACE,sBAAA;AAeN;AAhBI;EACE,sBAAA;AAkBN;AAnBI;EACE,sBAAA;AAqBN;AAtBI;EACE,sBAAA;AAwBN;AAzBI;EACE,sBAAA;AA2BN;AA5BI;EACE,sBAAA;AA8BN;AA/BI;EACE,sBAAA;AAiCN;AAlCI;EACE,sBAAA;AAoCN;AArCI;EACE,sBAAA;AAuCN;AAxCI;EACE,sBAAA;AA0CN;AA3CI;EACE,sBAAA;AA6CN;AA9CI;EACE,sBAAA;AAgDN;AAjDI;EACE,sBAAA;AAmDN;AApDI;EACE,sBAAA;AAsDN;AAvDI;EACE,sBAAA;AAyDN;AA1DI;EACE,sBAAA;AA4DN;AA7DI;EACE,sBAAA;AA+DN;AAhEI;EACE,sBAAA;AAkEN;AAnEI;EACE,sBAAA;AAqEN;AAtEI;EACE,sBAAA;AAwEN;AAzEI;EACE,sBAAA;AA2EN;AA5EI;EACE,sBAAA;AA8EN;;AAzEA;EACE,qGAAA;EACA,4BAAA;EACA,0CAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;AA4EF;AA1EE;EACE,6IACE;EAEF,2BAAA;AA0EJ;AAvEE;EACE,sBAAA;EACA,uCAAA;AAyEJ;AAtEE;EACE,YAAA;EACA,sBAAA;AAwEJ;AArEE;EACE,0DAAA;EACA,0EAAA;AAuEJ;AArEI;EACE,iFAAA;AAuEN;;AAlEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAqEF;AAnEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kCAAA;AAqEJ;AAnEI;EACE,kBAAA;EACA,oCAAA;AAqEN;AAlEI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AAoEN;AAlEM;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,8CAAA;AAoER;AA/DE;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;AAiEJ;;AA7DA;EACE,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;AAgEF;;AA7DA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAgEF;AA9DE;EACE,iBAAA;AAgEJ;AA7DE;EACE,kCAAA;EACA,cAAA;AA+DJ;AA5DE;EACE,mCAAA;EACA,cAAA;AA8DJ;;AA1DA;EACE,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AA6DF;;AA1DA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AA6DF;;AA1DA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA6DF;AA3DE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,mCAAA;EACA,cAAA;AA6DJ;AA1DE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qEAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA4DJ;AA1DI;EACE,iBAAA;EACA,iCAAA;AA4DN;AAxDE;EACE,aAAA;EACA,sBAAA;AA0DJ;AAxDI;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,gBAAA;AA0DN;AAvDI;EACE,wBAAA;EACA,kBAAA;EACA,oCAAA;EACA,gBAAA;AAyDN;;AApDA;EACE,wBAAA;EACA,kBAAA;EACA,qCAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AAuDF;AArDE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,qEAAA;EACA,oBAAA;AAuDJ;;AAnDA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;EACA,yCAAA;AAsDF;AApDE;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAsDJ;AAnDE;EACE,aAAA;EACA,QAAA;EACA,cAAA;AAqDJ;;AAjDA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,wBAAA;EACA,kBAAA;EACA,qCAAA;AAoDF;AAlDE;EACE,kBAAA;EACA,oCAAA;AAoDJ;;AAhDA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,0CAAA;EACA,oCAAA;AAmDF;AAjDE;EACE,eAAA;AAmDJ;AAhDE;EACE,+BAAA;EACA,qCAAA;AAkDJ;AA/CE;EACE,qBAAA;AAiDJ;;AA1CA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AA6CF;AA3CE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oEAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA6CJ;AA3CI;EACE,eAAA;EACA,iCAAA;EACA,YAAA;EACA,4CAAA;AA6CN;AAzCE;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,eAAA;AA2CJ;AAxCE;EACE,wBAAA;EACA,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AA0CJ;AAvCE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,0CAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sCAAA;EACA,sCAAA;EACA,YAAA;EACA,eAAA;EACA,0CAAA;AAyCJ;AAvCI;EACE,YAAA;EACA,2BAAA;AAyCN;AAtCI;EACE,sBAAA;AAwCN;;AAhCA;EACE,iBAAA;EACA,mCAAA;AAmCF;AAjCE;EACE,mCAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAmCJ;AAjCI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,qCAAA;AAmCN;AAhCI;EACE,YAAA;EACA,kBAAA;EACA,4GAAA;EAKA,0BAAA;EACA,4CAAA;EACA,mBAAA;AA8BN;AA5BM;EACE,UAAA;EACA,YAAA;AA8BR;AA3BM;EACE,UAAA;EACA,YAAA;AA6BR;AA1BM;EACE,UAAA;AA4BR;AAzBM;EACE,UAAA;EACA,gBAAA;AA2BR;AAvBI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAyBN;AAvBM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4GAAA;EAKA,0BAAA;EACA,4CAAA;AAqBR;AAlBM;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,4GAAA;EAKA,0BAAA;EACA,4CAAA;AAgBR;;AAPA;EACE,uBAAA;EACA,8BAAA;AAUF;;AAPA;EACE,uCAAA;EACA,2BAAA;EACA,mCAAA;EACA,oBAAA;EACA,uEAAA;AAUF;AARE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,qCAAA;EACA,2BAAA;EACA,mCAAA;EACA,oBAAA;EACA,WAAA;AAUJ;;AANA;EACE;IAAO,UAAA;IAAY,2BAAA;EAWnB;EAVA;IAAK,UAAA;IAAY,wBAAA;EAcjB;AACF;AAZA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,aAAA;EACA,4CAAA;AAcF;AAZE;EACE,OAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mCAAA;EACA,SAAA;EACA,uBAAA;AAcJ;AAXE;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;EACA,uBAAA;EACA,mFAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,0CAAA;AAaJ;AAXI;EACE,0EAAA;AAaN;AAVI;EACE,sBAAA;AAYN;AARE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,YAAA;EACA,eAAA;EACA,oCAAA;EACA,eAAA;EACA,0CAAA;AAUJ;AARI;EACE,+BAAA;EACA,qCAAA;AAUN;AAPI;EACE,qBAAA;AASN;;AAJA;EACE,+BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AAOF;AALE;EAAiB,qBAAA;AAQnB;AAPE;EAAiB,sBAAA;AAUnB;AATE;EAAiB,sBAAA;AAYnB;AAVE;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oCAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AAYJ;AATE;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAWJ;;AAPA;EACE;IAAO,UAAA;IAAY,0BAAA;EAYnB;EAXA;IAAK,UAAA;IAAY,wBAAA;EAejB;AACF;AAbA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,0CAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qCAAA;EACA,oCAAA;EACA,0BAAA;EACA,kCAAA;EACA,uCAAA;EACA,eAAA;EACA,0CAAA;EACA,yBAAA;UAAA,iBAAA;EACA,iFAAA;AAeF;AAbE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,iDAAA;AAeJ;AAZE;EACE,gCAAA;EACA,iFAAA;AAcJ;AAXE;EACE,sBAAA;AAaJ;AAVE;EACE,wFAAA;EACA,wCAAA;EACA,iCAAA;EACA,gBAAA;EACA,6HAAA;AAYJ;AAVI;EACE,qFAAA;AAYN;AAPI;EACE,kBAAA;EACA,YAAA;EACA,8CAAA;AASN;AALM;EACE,UAAA;AAOR;;AAEA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sCAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,eAAA;EACA,sCAAA;EACA,yBAAA;UAAA,iBAAA;AACF;AACE;EACE,iBAAA;AACJ;AAEE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,wCAAA;AAAJ;AAGE;EACE,sBAAA;EACA,0CAAA;AADJ;AAIE;EACE,sBAAA;AAFJ;;AAMA;EACE;IACE,YAAA;IACA,+BAAA;EAHF;AACF;AASA;EACE;IACE,UAAA;IACA,2BAAA;EAPF;EASA;IACE,UAAA;IACA,wBAAA;EAPF;AACF;AAUA;EACE;IACE,2BAAA;EARF;EAUA;IACE,4BAAA;EARF;AACF;AAWA;EACE;IACE,wBAAA;EATF;EAWA;IACE,2BAAA;EATF;AACF;AAYA;EACE;IACE,UAAA;IACA,sCAAA;EAVF;EAYA;IACE,UAAA;IACA,iCAAA;EAVF;AACF;AAaA;EACE;IACE,UAAA;IACA,mBAAA;EAXF;EAaA;IACE,YAAA;IACA,qBAAA;EAXF;AACF;AAiBA;EACE;;;;;;IAME,gBAAA;IACA,iBAAA;IACA,kBAAA;EAfF;EAkBA;IACE,kBAAA;EAhBF;AACF;AAmBA;EACE;IACE,iBAAA;EAjBF;AACF","sourcesContent":["// ============================================\n// SCHEDULE REDESIGN — \"Timeline Fluida\"\n// Complete visual overhaul. Every pixel is new.\n// ============================================\n\n// --- Design Tokens (override via event colors) ---\n:host {\n  --schedule-surface: #f5f7fa;\n  --schedule-card-bg: #ffffff;\n  --schedule-card-radius: 16px;\n  --schedule-card-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);\n  --schedule-card-shadow-hover: 0 4px 24px rgba(0, 0, 0, 0.10);\n  --schedule-text-primary: #1a1a2e;\n  --schedule-text-secondary: #6b7280;\n  --schedule-text-tertiary: #9ca3af;\n  --schedule-pill-radius: 100px;\n  --schedule-transition: 250ms cubic-bezier(0.4, 0, 0.2, 1);\n  --schedule-spring: 400ms cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n// ============================================\n// HEADER (structure preserved, style refreshed)\n// ============================================\nion-header {\n  ion-toolbar {\n    --padding-start: 8px;\n    --padding-end: 8px;\n    --min-height: 52px;\n\n    ion-title {\n      font-family: var(--font);\n      font-weight: 600;\n      font-size: 1.1rem;\n      letter-spacing: -0.01em;\n    }\n\n    ion-buttons {\n      ion-back-button, ion-menu-button {\n        --color: currentColor;\n      }\n    }\n\n    ion-searchbar {\n      --border-radius: 12px;\n      --box-shadow: none;\n      --background: rgba(255, 255, 255, 0.15);\n      padding: 0 4px;\n      font-size: 0.9rem;\n    }\n  }\n}\n\n// ============================================\n// DATE PILL STRIP\n// ============================================\n.date-pill-strip-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background: var(--schedule-surface);\n}\n\n.date-pill-strip {\n  display: flex;\n  gap: 8px;\n  padding: 12px 16px;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  background: var(--schedule-surface);\n  flex: 1;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  .date-pill {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 8px 20px;\n    border-radius: var(--schedule-pill-radius);\n    background: var(--schedule-card-bg);\n    border: 1px solid rgba(0, 0, 0, 0.06);\n    cursor: pointer;\n    transition: all var(--schedule-transition);\n    user-select: none;\n    position: relative;\n    opacity: 0;\n    transform: translateY(8px);\n    animation: pillFadeIn 350ms ease-out forwards;\n\n    @for $i from 1 through 20 {\n      &:nth-child(#{$i}) {\n        animation-delay: #{$i * 30}ms;\n      }\n    }\n\n    .pill-label {\n      font-family: var(--font);\n      font-size: 0.82rem;\n      font-weight: 500;\n      color: var(--schedule-text-secondary);\n      white-space: nowrap;\n      transition: color var(--schedule-transition);\n    }\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.03);\n    }\n\n    &:active {\n      transform: scale(0.95);\n    }\n\n    &.active {\n      background: var(--menu-color, #2973a2);\n      border-color: var(--menu-color, #2973a2);\n      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.10);\n\n      .pill-label {\n        color: var(--menu-text-color, #ffffff);\n        font-weight: 600;\n      }\n    }\n\n    &.today {\n      &::after {\n        content: '';\n        position: absolute;\n        top: 4px;\n        right: 4px;\n        width: 6px;\n        height: 6px;\n        border-radius: 50%;\n        background: #ef4444;\n      }\n    }\n\n    &.active.today::after {\n      background: rgba(255, 255, 255, 0.7);\n    }\n  }\n}\n\n.scroll-btn {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: none;\n  background: var(--schedule-card-bg);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);\n  color: var(--schedule-text-secondary);\n  cursor: pointer;\n  flex-shrink: 0;\n  z-index: 2;\n  transition: all var(--schedule-transition);\n  margin: 0 4px;\n\n  ion-icon {\n    font-size: 1rem;\n  }\n\n  &:hover {\n    background: color-mix(in srgb, var(--menu-color, #2973a2) 10%, white);\n    color: var(--menu-color, #2973a2);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.14);\n  }\n\n  &:active {\n    transform: scale(0.9);\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .scroll-btn {\n    display: flex;\n  }\n}\n\n// ============================================\n// SCHEDULE TOOLBAR (search + filters)\n// ============================================\n.schedule-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 16px 12px;\n  background: var(--schedule-surface);\n\n  .toolbar-search {\n    flex: 1;\n    position: relative;\n\n    ion-searchbar {\n      --border-radius: 12px;\n      --box-shadow: none;\n      --background: var(--schedule-card-bg);\n      --placeholder-color: var(--schedule-text-tertiary);\n      --placeholder-font-weight: 400;\n      --icon-color: var(--schedule-text-tertiary);\n      --clear-button-color: var(--schedule-text-tertiary);\n      --cancel-button-color: var(--menu-color, #2973a2);\n      padding: 0;\n      height: 42px;\n      font-family: var(--font);\n      font-size: 0.9rem;\n      transition: all var(--schedule-transition);\n\n      &.sc-ion-searchbar-ios {\n        --background: var(--schedule-card-bg);\n      }\n\n      &.searchbar-collapsed {\n        --background: color-mix(in srgb, var(--menu-color, #2973a2) 4%, white);\n        --placeholder-color: var(--schedule-text-tertiary);\n\n        .searchbar-input-container {\n          border: 1px solid rgba(0, 0, 0, 0.04);\n        }\n\n        .searchbar-cancel-button {\n          display: none !important;\n        }\n      }\n\n      &:focus-within,\n      &.searchbar-has-focus {\n        --background: white;\n        --box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n      }\n    }\n  }\n}\n\n// ============================================\n// ICS DOWNLOAD ROW\n// ============================================\n.ics-download-row {\n  display: flex;\n  justify-content: center;\n  padding: 4px 16px 12px;\n  background: var(--schedule-surface);\n\n  .ics-button {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 20px;\n    border-radius: var(--schedule-pill-radius);\n    font-family: var(--font);\n    font-size: 0.8rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all var(--schedule-transition);\n    border: none;\n    background: color-mix(in srgb, var(--menu-color, #2973a2) 10%, white);\n    color: var(--menu-color, #2973a2);\n\n    ion-icon {\n      font-size: 1rem;\n    }\n\n    &:hover {\n      background: color-mix(in srgb, var(--menu-color, #2973a2) 18%, white);\n    }\n\n    &:active {\n      transform: scale(0.97);\n    }\n  }\n}\n\n// ============================================\n// SESSION LIST (Timeline)\n// ============================================\n.schedule-timeline {\n  padding: 8px 16px 80px;\n  background: var(--schedule-surface);\n\n  // Timeline vertical line\n  position: relative;\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: 27px;\n    top: 12px;\n    bottom: 12px;\n    width: 2px;\n    background: rgba(0, 0, 0, 0.06);\n    border-radius: 2px;\n    pointer-events: none;\n  }\n}\n\n// ============================================\n// SESSION CARD\n// ============================================\n.session-card-wrapper {\n  position: relative;\n  margin-bottom: 12px;\n\n  // Animation on appear\n  opacity: 0;\n  transform: translateY(12px);\n  animation: cardFadeIn 400ms ease-out forwards;\n\n  @for $i from 1 through 30 {\n    &:nth-child(#{$i}) {\n      animation-delay: #{$i * 30}ms;\n    }\n  }\n}\n\n.session-card {\n  --card-tint: color-mix(in srgb, var(--session-track-color, transparent) 11%, var(--schedule-card-bg));\n  background: var(--card-tint);\n  border-radius: var(--schedule-card-radius);\n  box-shadow: var(--schedule-card-shadow);\n  padding: 14px 16px;\n  cursor: pointer;\n  transition: all var(--schedule-transition);\n  position: relative;\n  overflow: hidden;\n  border: 1px solid transparent;\n\n  &:hover {\n    box-shadow:\n      var(--schedule-card-shadow-hover),\n      0 0 0 1px color-mix(in srgb, var(--session-track-color, rgba(0,0,0,0.04)) 18%, transparent);\n    transform: translateY(-1px);\n  }\n\n  &:active {\n    transform: scale(0.98);\n    box-shadow: var(--schedule-card-shadow);\n  }\n\n  &.is-past {\n    opacity: 0.4;\n    filter: grayscale(0.4);\n  }\n\n  &.is-now {\n    border-color: color-mix(in srgb, #ef4444 25%, transparent);\n    box-shadow: 0 2px 20px rgba(239, 68, 68, 0.10), var(--schedule-card-shadow);\n\n    &:hover {\n      box-shadow: 0 4px 28px rgba(239, 68, 68, 0.15), var(--schedule-card-shadow-hover);\n    }\n  }\n}\n\n.card-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n\n  .card-time {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-family: var(--font);\n    font-size: 0.82rem;\n    font-weight: 600;\n    color: var(--schedule-text-primary);\n    font-variant-numeric: tabular-nums;\n\n    ion-icon {\n      font-size: 0.85rem;\n      color: var(--schedule-text-tertiary);\n    }\n\n    .live-indicator {\n      display: inline-flex;\n      align-items: center;\n      gap: 4px;\n      font-weight: 700;\n      font-size: 0.7rem;\n      color: #ef4444;\n      text-transform: uppercase;\n      letter-spacing: 0.03em;\n\n      .live-dot {\n        width: 7px;\n        height: 7px;\n        border-radius: 50%;\n        background: #ef4444;\n        animation: livePulse 1.5s ease-in-out infinite;\n      }\n    }\n  }\n\n  .card-tracks {\n    display: flex;\n    gap: 4px;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n  }\n}\n\n.track-chip {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  line-height: 1.5;\n}\n\n.card-availability-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 5px;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 0.68rem;\n  font-weight: 600;\n  line-height: 1.5;\n\n  ion-icon {\n    font-size: 0.8rem;\n  }\n\n  &.sold-out {\n    background: rgba(239, 68, 68, 0.10);\n    color: #dc2626;\n  }\n\n  &.few-tickets {\n    background: rgba(245, 158, 11, 0.10);\n    color: #d97706;\n  }\n}\n\n.card-title {\n  font-family: var(--font);\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--schedule-text-primary);\n  margin: 0 0 8px;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.card-speakers {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.card-speaker {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  .speaker-avatar {\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    object-fit: cover;\n    background: var(--schedule-surface);\n    flex-shrink: 0;\n  }\n\n  .speaker-avatar-placeholder {\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    background: color-mix(in srgb, var(--menu-color, #2973a2) 12%, white);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n\n    ion-icon {\n      font-size: 0.7rem;\n      color: var(--menu-color, #2973a2);\n    }\n  }\n\n  .speaker-info {\n    display: flex;\n    flex-direction: column;\n\n    .speaker-name {\n      font-family: var(--font);\n      font-size: 0.78rem;\n      font-weight: 500;\n      color: var(--schedule-text-primary);\n      line-height: 1.2;\n    }\n\n    .speaker-title {\n      font-family: var(--font);\n      font-size: 0.68rem;\n      color: var(--schedule-text-tertiary);\n      line-height: 1.2;\n    }\n  }\n}\n\n.card-description {\n  font-family: var(--font);\n  font-size: 0.78rem;\n  color: var(--schedule-text-secondary);\n  line-height: 1.5;\n  position: relative;\n  max-height: 2.4em;\n  overflow: hidden;\n\n  &::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 1.2em;\n    background: linear-gradient(to bottom, transparent, var(--card-tint));\n    pointer-events: none;\n  }\n}\n\n.card-bottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding-top: 8px;\n  border-top: 1px solid rgba(0, 0, 0, 0.04);\n\n  .card-locations {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n  }\n\n  .card-actions {\n    display: flex;\n    gap: 4px;\n    flex-shrink: 0;\n  }\n}\n\n.location-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-family: var(--font);\n  font-size: 0.72rem;\n  color: var(--schedule-text-secondary);\n\n  ion-icon {\n    font-size: 0.78rem;\n    color: var(--schedule-text-tertiary);\n  }\n}\n\n.action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all var(--schedule-transition);\n  color: var(--schedule-text-tertiary);\n\n  ion-icon {\n    font-size: 1rem;\n  }\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.04);\n    color: var(--schedule-text-secondary);\n  }\n\n  &:active {\n    transform: scale(0.9);\n  }\n}\n\n// ============================================\n// EMPTY STATE\n// ============================================\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 32px;\n  text-align: center;\n\n  .empty-illustration {\n    width: 120px;\n    height: 120px;\n    margin-bottom: 20px;\n    border-radius: 60px;\n    background: color-mix(in srgb, var(--menu-color, #2973a2) 8%, white);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    ion-icon {\n      font-size: 3rem;\n      color: var(--menu-color, #2973a2);\n      opacity: 0.5;\n      animation: floatIcon 3s ease-in-out infinite;\n    }\n  }\n\n  .empty-title {\n    font-family: var(--font);\n    font-size: 1.05rem;\n    font-weight: 600;\n    color: var(--schedule-text-primary);\n    margin: 0 0 6px;\n  }\n\n  .empty-text {\n    font-family: var(--font);\n    font-size: 0.85rem;\n    color: var(--schedule-text-tertiary);\n    margin: 0 0 20px;\n    max-width: 240px;\n    line-height: 1.5;\n  }\n\n  .empty-cta {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 10px 24px;\n    border-radius: var(--schedule-pill-radius);\n    font-family: var(--font);\n    font-size: 0.85rem;\n    font-weight: 500;\n    background: var(--menu-color, #2973a2);\n    color: var(--menu-text-color, #ffffff);\n    border: none;\n    cursor: pointer;\n    transition: all var(--schedule-transition);\n\n    &:hover {\n      opacity: 0.9;\n      transform: translateY(-1px);\n    }\n\n    &:active {\n      transform: scale(0.97);\n    }\n  }\n}\n\n// ============================================\n// LOADING SKELETON\n// ============================================\n.skeleton-list {\n  padding: 8px 16px;\n  background: var(--schedule-surface);\n\n  .skeleton-card {\n    background: var(--schedule-card-bg);\n    border-radius: var(--schedule-card-radius);\n    padding: 16px;\n    margin-bottom: 12px;\n    margin-left: 36px;\n    position: relative;\n\n    &::before {\n      content: '';\n      position: absolute;\n      left: -27px;\n      top: 20px;\n      width: 10px;\n      height: 10px;\n      border-radius: 50%;\n      background: var(--schedule-surface);\n      border: 2px solid rgba(0, 0, 0, 0.06);\n    }\n\n    .skeleton-line {\n      height: 12px;\n      border-radius: 6px;\n      background: linear-gradient(90deg,\n        rgba(0, 0, 0, 0.03) 0%,\n        rgba(0, 0, 0, 0.07) 40%,\n        rgba(0, 0, 0, 0.03) 80%\n      );\n      background-size: 300% 100%;\n      animation: shimmer 1.8s ease-in-out infinite;\n      margin-bottom: 10px;\n\n      &:nth-child(1) {\n        width: 30%;\n        height: 10px;\n      }\n\n      &:nth-child(2) {\n        width: 90%;\n        height: 14px;\n      }\n\n      &:nth-child(3) {\n        width: 60%;\n      }\n\n      &:nth-child(4) {\n        width: 45%;\n        margin-bottom: 0;\n      }\n    }\n\n    .skeleton-row {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      margin-bottom: 10px;\n\n      .skeleton-avatar {\n        width: 24px;\n        height: 24px;\n        border-radius: 50%;\n        background: linear-gradient(90deg,\n          rgba(0, 0, 0, 0.03) 0%,\n          rgba(0, 0, 0, 0.07) 40%,\n          rgba(0, 0, 0, 0.03) 80%\n        );\n        background-size: 300% 100%;\n        animation: shimmer 1.8s ease-in-out infinite;\n      }\n\n      .skeleton-name {\n        height: 10px;\n        width: 130px;\n        border-radius: 5px;\n        background: linear-gradient(90deg,\n          rgba(0, 0, 0, 0.03) 0%,\n          rgba(0, 0, 0, 0.07) 40%,\n          rgba(0, 0, 0, 0.03) 80%\n        );\n        background-size: 300% 100%;\n        animation: shimmer 1.8s ease-in-out infinite;\n      }\n    }\n  }\n}\n\n// ============================================\n// FILTER BOTTOM SHEET\n// ============================================\n.filter-sheet {\n  --backdrop-opacity: 0.3;\n  --border-radius: 24px 24px 0 0;\n}\n\n.filter-sheet-content {\n  --background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(24px);\n  -webkit-backdrop-filter: blur(24px);\n  padding: 0 20px 28px;\n  animation: sheetFadeIn 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    height: 300px;\n    background: rgba(255, 255, 255, 0.92);\n    backdrop-filter: blur(24px);\n    -webkit-backdrop-filter: blur(24px);\n    pointer-events: none;\n    z-index: -1;\n  }\n}\n\n@keyframes sheetFadeIn {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.sheet-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 20px;\n  padding: 16px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n\n  .sheet-title {\n    flex: 1;\n    font-family: var(--font);\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: var(--schedule-text-primary);\n    margin: 0;\n    letter-spacing: -0.01em;\n  }\n\n  .sheet-clear {\n    font-family: var(--font);\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: var(--menu-color, #2973a2);\n    background: transparent;\n    border: 1.5px solid color-mix(in srgb, var(--menu-color, #2973a2) 25%, transparent);\n    cursor: pointer;\n    padding: 5px 12px;\n    border-radius: 100px;\n    transition: all var(--schedule-transition);\n\n    &:hover {\n      background: color-mix(in srgb, var(--menu-color, #2973a2) 8%, transparent);\n    }\n\n    &:active {\n      transform: scale(0.95);\n    }\n  }\n\n  .sheet-close {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    background: rgba(0, 0, 0, 0.05);\n    border: none;\n    cursor: pointer;\n    color: var(--schedule-text-tertiary);\n    font-size: 1rem;\n    transition: all var(--schedule-transition);\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.08);\n      color: var(--schedule-text-secondary);\n    }\n\n    &:active {\n      transform: scale(0.9);\n    }\n  }\n}\n\n.sheet-section {\n  background: rgba(0, 0, 0, 0.02);\n  border-radius: 14px;\n  padding: 14px;\n  margin-bottom: 12px;\n  animation: sheetSectionIn 0.4s ease forwards;\n  opacity: 0;\n\n  &:nth-child(1) { animation-delay: 0.1s; }\n  &:nth-child(2) { animation-delay: 0.18s; }\n  &:nth-child(3) { animation-delay: 0.26s; }\n\n  .sheet-section-title {\n    font-family: var(--font);\n    font-size: 0.72rem;\n    font-weight: 700;\n    color: var(--schedule-text-tertiary);\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    margin: 0 0 10px;\n  }\n\n  .sheet-chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n}\n\n@keyframes sheetSectionIn {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.sheet-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border-radius: var(--schedule-pill-radius);\n  font-family: var(--font);\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: var(--schedule-text-secondary);\n  background: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border: 1.5px solid rgba(0, 0, 0, 0.06);\n  cursor: pointer;\n  transition: all var(--schedule-transition);\n  user-select: none;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), inset 0 1px 0 rgba(255, 255, 255, 0.5);\n\n  .chip-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    flex-shrink: 0;\n    transition: box-shadow var(--schedule-transition);\n  }\n\n  &:hover {\n    border-color: rgba(0, 0, 0, 0.1);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06), inset 0 1px 0 rgba(255, 255, 255, 0.5);\n  }\n\n  &:active {\n    transform: scale(0.96);\n  }\n\n  &.active {\n    background: color-mix(in srgb, var(--menu-color, #2973a2) 12%, rgba(255, 255, 255, 0.9));\n    border-color: var(--menu-color, #2973a2);\n    color: var(--menu-color, #2973a2);\n    font-weight: 600;\n    box-shadow: 0 2px 8px color-mix(in srgb, var(--menu-color, #2973a2) 15%, transparent), inset 0 1px 0 rgba(255, 255, 255, 0.6);\n\n    .chip-dot {\n      box-shadow: 0 0 0 2px color-mix(in srgb, var(--menu-color, #2973a2) 20%, transparent);\n    }\n  }\n\n  &.sheet-chip-location {\n    ion-icon {\n      font-size: 0.85rem;\n      opacity: 0.6;\n      transition: opacity var(--schedule-transition);\n    }\n\n    &.active {\n      ion-icon {\n        opacity: 1;\n      }\n    }\n  }\n}\n\n// ============================================\n// FILTER FAB\n// ============================================\n.filter-fab {\n  position: fixed;\n  bottom: 24px;\n  right: 20px;\n  z-index: 100;\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  background: var(--menu-color, #2973a2);\n  color: var(--menu-text-color, #ffffff);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);\n  cursor: pointer;\n  transition: all var(--schedule-spring);\n  user-select: none;\n\n  ion-icon {\n    font-size: 1.3rem;\n  }\n\n  .filter-fab-badge {\n    position: absolute;\n    top: -2px;\n    right: -2px;\n    min-width: 20px;\n    height: 20px;\n    border-radius: 10px;\n    background: #ef4444;\n    color: white;\n    font-size: 0.65rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 5px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n  }\n\n  &:hover {\n    transform: scale(1.05);\n    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.22);\n  }\n\n  &:active {\n    transform: scale(0.92);\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .filter-fab {\n    bottom: 32px;\n    right: calc(50% - 480px + 20px);\n  }\n}\n\n// ============================================\n// KEYFRAMES\n// ============================================\n@keyframes cardFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n@keyframes floatIcon {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-6px);\n  }\n}\n\n@keyframes pillFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes livePulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.5;\n    transform: scale(0.8);\n  }\n}\n\n// ============================================\n// RESPONSIVE\n// ============================================\n@media screen and (min-width: 768px) {\n  .schedule-timeline,\n  .date-pill-strip-container,\n  .schedule-toolbar,\n  .ics-download-row,\n  .skeleton-list,\n  .empty-state {\n    max-width: 900px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .empty-state {\n    padding: 80px 16px;\n  }\n}\n\n@media screen and (min-width: 769px) {\n  .date-pill-strip {\n    padding: 12px 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
